import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from 'base-pdf-view-library';
import { BasePdfViewLibraryService } from 'base-pdf-view-library';
import * as i1 from '@ngrx/store';
import * as i3 from 'app-services-library';
import * as i4 from '@angular/common';
import * as i5 from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class PdfViewLibraryService {
    constructor() { }
}
PdfViewLibraryService.ɵfac = function PdfViewLibraryService_Factory(t) { return new (t || PdfViewLibraryService)(); };
PdfViewLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: PdfViewLibraryService, factory: PdfViewLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PdfViewLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function PdfViewLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelement(2, "ngx-extended-pdf-viewer", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.pdfSrc);
} }
class PdfViewLibraryComponent extends BasePdfViewLibraryService {
    constructor(store, apiService, appServicesLibraryService) {
        super(store, apiService, appServicesLibraryService);
        this.store = store;
        this.apiService = apiService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        super.loadInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
PdfViewLibraryComponent.ɵfac = function PdfViewLibraryComponent_Factory(t) { return new (t || PdfViewLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIPdfView), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService)); };
PdfViewLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PdfViewLibraryComponent, selectors: [["pdf-view-library"]], inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 1, consts: [[1, "col-md-12", "row", "p-0"], ["class", "row", 4, "ngIf"], [1, "row", "col-md-12", "dasheedTopBorder", "mt-3", "pt-3", "p-0"], [1, "col-md-1", "p-0"], ["color", "primary", 1, "pull-left", "backContBtn", 3, "click"], [1, "fa", "back-continue-icon", "fa-angle-left"], [1, "row"], [1, "col", 2, "width", "680px"], ["height", "80vh", "useBrowserLocale", "true", 1, "letter-pdf", 2, "width", "100%", 3, "src"]], template: function PdfViewLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PdfViewLibraryComponent_div_1_Template, 3, 1, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "a", 4);
        i0.ɵɵlistener("click", function PdfViewLibraryComponent_Template_a_click_4_listener() { return ctx.backLink(); });
        i0.ɵɵelement(5, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.pdfSrc);
    } }, directives: [i4.NgIf, i5.NgxExtendedPdfViewerComponent], styles: [".step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PdfViewLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'pdf-view-library',
                templateUrl: 'pdf-view-library.component.html',
                styleUrls: ['pdf-view-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIPdfView }, { type: i3.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class PdfViewLibraryModule {
}
PdfViewLibraryModule.ɵfac = function PdfViewLibraryModule_Factory(t) { return new (t || PdfViewLibraryModule)(); };
PdfViewLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PdfViewLibraryModule });
PdfViewLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BasePdfViewLibraryService], imports: [[
            PrimengLibraryModule,
            NgxExtendedPdfViewerModule,
            StepStatusUpdateComponentLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PdfViewLibraryModule, { declarations: [PdfViewLibraryComponent], imports: [PrimengLibraryModule,
        NgxExtendedPdfViewerModule,
        StepStatusUpdateComponentLibraryModule], exports: [PdfViewLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PdfViewLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [PdfViewLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    NgxExtendedPdfViewerModule,
                    StepStatusUpdateComponentLibraryModule
                ],
                providers: [BasePdfViewLibraryService],
                exports: [PdfViewLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of pdf-view-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PdfViewLibraryComponent, PdfViewLibraryModule, PdfViewLibraryService };
//# sourceMappingURL=pdf-view-library.js.map
